import { Accordion, Box, Link, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const MobileMenuWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };
}) as typeof Box;

export const CustomAccordion = styled(Accordion)({
  borderRadius: '4px',
  backgroundColor: palette.primary.purple50,
  boxShadow: 'none',
  border: 'none',
  borderLeft: `4px solid ${palette.primary.purple500}`,

  '&.Mui-expanded': {
    margin: 0,
  },

  '.MuiButtonBase-root': {
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
  },

  '.MuiAccordionSummary-content': {
    margin: '16px 0',

    '&.Mui-expanded': {
      margin: '16px 0',
    },
  },

  '.MuiSvgIcon-root': {
    fill: palette.unknown.icon_grey,
  },

  '.MuiAccordionDetails-root': {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 16px 24px 16px',
  },

  '&::before': {
    display: 'none',
  },

  '&:first-of-type': {
    borderRadius: '4px',
  },

  '&:last-of-type': {
    borderRadius: '4px',
  },
});

export const AccordionTitle = styled(Typography)({
  color: palette.text.header,
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '128%',
  letterSpacing: '0%',
}) as typeof Typography;

export const AccordionDescLink = styled(Link)({
  color: palette.primary.purple500,
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '136%',
  padding: '10px 0',
  textDecoration: 'none',
}) as typeof Link;

export const MenuExternalItemLink = styled(AccordionDescLink)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  };
});
